var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 22.655C19.6783 22.655 22.6601 19.6732 22.6601 15.995C22.6601 12.3168 19.6783 9.33501 16.0001 9.33501C12.3219 9.33501 9.34009 12.3168 9.34009 15.995C9.34009 19.6732 12.3219 22.655 16.0001 22.655Z",
    fill: "#FFBB19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.005C16.55 8.005 17 7.555 17 7.005V3.675C17 3.125 16.55 2.675 16 2.675C15.45 2.675 15 3.125 15 3.675V7.005C15 7.565 15.44 8.005 16 8.005Z",
    fill: "#FFBB19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9301 10.345C9.3201 10.735 9.9501 10.735 10.3401 10.345C10.7301 9.955 10.7301 9.325 10.3401 8.935L7.9901 6.575C7.6001 6.185 6.9701 6.185 6.5801 6.575C6.1901 6.965 6.1901 7.595 6.5801 7.985L8.9301 10.345Z",
    fill: "#FFBB19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01004 15.995C8.01004 15.445 7.56004 14.995 7.01004 14.995H3.67004C3.12004 14.995 2.67004 15.445 2.67004 15.995C2.67004 16.545 3.12004 16.995 3.67004 16.995H7.01004C7.56004 16.995 8.01004 16.555 8.01004 15.995Z",
    fill: "#FFBB19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93009 21.645L6.57009 24.005C6.18009 24.395 6.18009 25.025 6.57009 25.415C6.96009 25.805 7.59009 25.805 7.98009 25.415L10.3401 23.055C10.7301 22.665 10.7301 22.035 10.3401 21.645C9.96009 21.255 9.32009 21.255 8.93009 21.645Z",
    fill: "#FFBB19"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.985C15.45 23.985 15 24.435 15 24.985V28.325C15 28.875 15.45 29.325 16 29.325C16.55 29.325 17 28.875 17 28.325V24.985C17 24.435 16.55 23.985 16 23.985Z",
    fill: "#FFBB19"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.06 21.645C22.67 21.255 22.04 21.255 21.65 21.645C21.26 22.035 21.26 22.665 21.65 23.055L24.01 25.415C24.4 25.805 25.03 25.805 25.42 25.415C25.81 25.025 25.81 24.395 25.42 24.005L23.06 21.645Z",
    fill: "#FFBB19"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.32 14.995H24.99C24.44 14.995 23.99 15.445 23.99 15.995C23.99 16.545 24.44 16.995 24.99 16.995H28.33C28.88 16.995 29.33 16.545 29.33 15.995C29.32 15.445 28.88 14.995 28.32 14.995Z",
    fill: "#FFBB19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.06 10.345L25.42 7.985C25.81 7.595 25.81 6.965 25.42 6.575C25.03 6.185 24.4 6.185 24.01 6.575L21.65 8.935C21.26 9.325 21.26 9.955 21.65 10.345C22.04 10.735 22.67 10.735 23.06 10.345Z",
    fill: "#FFBB19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a3e78b6f79827f77584adcbecd6b8549.svg";
export { ForwardRef as ReactComponent };